<template>
    <div>
        <div class="top-area" v-if="content.areas[0].content">
            <render-editor-js :content="content.areas[0].content" :component="{}"/>
        </div>

        <b-field class="text-input-field" :message="(content.required) ? '* Response is required.' : ''">
            <b-input type="textarea" v-model="data[content.id]" :required="content.required" @blur="saveData"/>
        </b-field>

        <div class="bottom-area" v-if="content.areas[1].content">
            <render-editor-js :content="content.areas[1].content" :component="{}"/>
        </div>
    </div>
</template>

<script>

    import RenderEditorJs from "./RenderEditorJs.vue";

    export default {
        components: {RenderEditorJs},
        props: ['content', 'data'],
        data: function() {
            return {
                // data: null
            }
        },
        methods: {
            saveData() {
                let payload = {
                    block: JSON.stringify(this.content),
                    field: this.content.id,
                    value: JSON.stringify(this.data[this.content.id]),
                };

                this.$emit('save', payload);
            }
        },
        created() {
            // This is required to make the data reactive
            // this.data = this.content;
        }
    };
</script>

<style lang="scss">
    .text-input-field {
        padding: 0 2rem 1.2rem;
    }

    .top-area {
        .render-paragraph {
            margin-bottom: 0 !important;
            padding-bottom: 10px !important;
        }
    }
</style>
